import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'Eye',
      title: 'See All Finances in One Place',
      description: 'No more switching between apps or logging into multiple bank accounts. Everything you need is right here.',
      color: 'primary'
    },
    {
      icon: 'PieChart',
      title: 'Understand Where Money Goes',
      description: 'Clear visualizations and smart categorization show exactly how you spend, so there are no surprises.',
      color: 'accent'
    },
    {
      icon: 'Calendar',
      title: 'Stay Ahead of Bills & Payments',
      description: 'Never miss a payment again with reminders and a visual calendar that keeps you organized.',
      color: 'success'
    },
    {
      icon: 'Shield',
      title: 'Reduce Financial Stress',
      description: 'Feel confident knowing your money is tracked, organized, and under control—no more guessing.',
      color: 'secondary'
    },
    {
      icon: 'TrendingUp',
      title: 'Make Better Decisions',
      description: 'Use real insights from your spending patterns to make smarter choices about your money.',
      color: 'warning'
    },
    {
      icon: 'Smile',
      title: 'Gain Financial Confidence',
      description: 'Take control of your financial future with tools that empower you to save, plan, and grow.',
      color: 'primary'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'bg-primary/10 text-primary',
      accent: 'bg-accent/10 text-accent',
      success: 'bg-success/10 text-success',
      warning: 'bg-warning/10 text-warning',
      secondary: 'bg-secondary/10 text-secondary'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-background">
      <div className="mx-auto px-4 md:px-6 lg:px-24 max-w-7xl">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-secondary mb-3 md:mb-4">
            What You'll Gain
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Real benefits that make a difference in your daily financial life
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 lg:gap-8">
          {benefits?.map((benefit, index) => (
            <div
              key={index}
              className="bg-card rounded-xl md:rounded-2xl shadow-elevation-2 hover:shadow-elevation-3 transition-smooth p-5 md:p-6 lg:p-7"
            >
              <div className={`inline-flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-xl ${getColorClasses(benefit?.color)} mb-4`}>
                <Icon name={benefit?.icon} size={24} strokeWidth={2} />
              </div>
              <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-card-foreground mb-2 md:mb-3">
                {benefit?.title}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {benefit?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;